// Reserved for minimal logic that triggers "above the fold"

function setGlobalVariables() {
  window.config = window.config || {}

  window.state = {
    screens: {
      point: { raw: '(pointer: fine)' },
      touch: { raw: '(hover: none)' },
      xxs: '390px',
      xs: '576px',
      sm: '640px',
      md: '767px',
      lg: '1024px',
      xl: '1200px',
      xxl: '1400px',
      xxxl: '1600px',
    },
    mobileWidth: 768,
    overflow: {
      hiddenClass: 'overflow-hidden',
      autoClass: 'overflow-auto',
    },
    cart: {
      items: [],
      count: 0,
    },
  }
  // End legacy setup

  let previousWidth = window.innerWidth

  window.addEventListener('resize', () => {
    const currentWidth = window.innerWidth
    if (currentWidth !== previousWidth) {
      previousWidth = currentWidth
      updateGlobalVariables()
    }
  })

  updateGlobalVariables()
}

function updateGlobalVariables() {
  // Used for things like popups, drawers, etc. that need to be constrained within the viewable portion of a scroll-locked window
  document.body.style.setProperty('--inner-height', `${window.innerHeight}px`)

  setHeight({ selector: '.header-section', variable: 'mainNavHeight', property: '--main-nav-height' })
  setHeight({
    selector: 'gift-bundle-progress-bar',
    variable: 'giftBundleProgressBarHeight',
    property: '--gift-bundle-atc-position',
  })
  setHeight({
    selector: '[data-algolia-sticky-filter]',
    variable: 'algoliaStickyFilterHeight',
    property: '--algolia-sticky-filter-height',
  })
  setHeight({ selector: '.js-sub-nav', variable: 'searchHeight', property: '--search-height' })
  setHeight({
    selector: '[data-announcement-bar]',
    variable: 'announcementBarHeight',
    property: '--announcement-bar-height',
  })
  setHeight({ selector: '.js-sub-nav', variable: 'navHeight', property: '--nav-height' })
  setHeight({ selector: '[data-menu-tabs]', variable: 'tabsHeight', property: '--tabs-height' })
  setHeight({ selector: '.header-section', variable: 'foldHeight', property: '--fold-height', isFold: true })
}

function setHeight({ selector, variable, property, isFold, offset = 0 }) {
  // Find all elements matching the selector
  const elements = document.querySelectorAll(selector)
  // Find the first visible element
  let element = null

  for (const el of elements) {
    // Check if element is visible (not display: none and in the DOM)
    if (isVisible(el)) {
      element = el
      break
    }
  }

  if (element !== null) {
    window.config[variable] = element.offsetHeight
  } else {
    window.config[variable] = 0
  }

  if (isFold) {
    document.body.style.setProperty(property, `calc(100dvh - ${window.config[variable]}px)`)
  } else {
    document.body.style.setProperty(property, `${window.config[variable] + offset}px`)
  }
}

function isVisible(el) {
  // Check if element has dimensions (accounts for parent visibility too)
  if (el.offsetWidth === 0 && el.offsetHeight === 0) {
    return false
  }

  // Also check computed styles for visibility and opacity
  const style = window.getComputedStyle(el)
  return style.visibility !== 'hidden' && style.opacity !== '0'
}

setGlobalVariables()
